import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "@phosphor-icons/react";
import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { imgUrl, money, useCart, shippingFor } from "../cart";

export default function CartPage() {
  const { items, setQty, remove, subtotal } = useCart();
  const navigate = useNavigate();
  const ship = items.length ? shippingFor("Standard", subtotal) : 0;

  return (
    <>
      <SEO title="Your Basket | Emporium London" description="Review the items in your Emporium London basket and proceed to secure checkout." path="/cart" />
      <main>
        <PageHeader overline="Basket" title="Your basket" />
        <section className="relative z-10 px-6 md:px-12 lg:px-16 py-16 md:py-20">
          {items.length === 0 ? (
            <div data-testid="cart-empty" className="text-center py-20">
              <p className="font-serif text-3xl text-[var(--text-primary)]">Your basket is empty.</p>
              <Link to="/shop" className="mt-6 inline-block border border-black/20 px-8 h-14 leading-[3.5rem] font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-[var(--text-primary)] hover:text-[var(--bg-primary)] transition-colors">Browse the shop</Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2 divide-y divide-black/10 border-t border-black/10">
                {items.map((i) => (
                  <div key={i.id} data-testid={`cart-row-${i.id}`} className="flex gap-5 py-6 items-center">
                    <img src={imgUrl(i.image)} alt={i.name} className="w-24 h-24 object-cover bg-[var(--bg-tertiary)]" />
                    <div className="flex-1">
                      <h2 className="font-serif text-xl">{i.name}</h2>
                      <p className="font-mono text-[11px] text-[var(--text-muted)] mt-1">{money(i.price)} each</p>
                    </div>
                    <div className="flex items-center border border-black/20">
                      <button data-testid={`cart-dec-${i.id}`} onClick={() => setQty(i.id, i.qty - 1)} className="h-10 w-10 flex items-center justify-center hover:bg-black/5"><Minus size={12} /></button>
                      <span className="w-10 text-center font-mono text-sm">{i.qty}</span>
                      <button data-testid={`cart-inc-${i.id}`} onClick={() => setQty(i.id, i.qty + 1)} className="h-10 w-10 flex items-center justify-center hover:bg-black/5"><Plus size={12} /></button>
                    </div>
                    <div className="w-20 text-right font-serif text-lg">{money(i.price * i.qty)}</div>
                    <button data-testid={`cart-remove-${i.id}`} onClick={() => remove(i.id)} className="text-[var(--text-muted)] hover:text-[var(--text-primary)]"><X size={18} /></button>
                  </div>
                ))}
              </div>
              <div className="bg-[var(--bg-secondary)] p-8 h-fit">
                <h2 className="font-serif text-2xl mb-6">Summary</h2>
                <div className="space-y-3 font-mono text-[12px] tracking-[0.1em] uppercase text-[var(--text-secondary)]">
                  <div className="flex justify-between"><span>Subtotal</span><span data-testid="cart-subtotal">{money(subtotal)}</span></div>
                  <div className="flex justify-between"><span>Shipping (from)</span><span>{ship === 0 ? "Free" : money(ship)}</span></div>
                  <div className="flex justify-between text-[var(--text-primary)] text-sm pt-3 border-t border-black/10"><span>Total (from)</span><span data-testid="cart-total">{money(subtotal + ship)}</span></div>
                </div>
                <p className="mt-3 font-mono text-[10px] text-[var(--text-muted)]">Prices include VAT. Final shipping shown at checkout.</p>
                <button data-testid="cart-checkout" onClick={() => navigate("/checkout")} className="mt-6 w-full bg-[var(--text-primary)] text-[var(--bg-primary)] h-14 font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-[var(--brass)] transition-colors">Checkout</button>
              </div>
            </div>
          )}
        </section>
      </main>
    </>
  );
}
